import {baseApi} from "../baseApi";
import {IAppointmentsResponse, IGetAppointmentFilter} from "./types";

const endpoints = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        getAppointments: builder.query<IAppointmentsResponse, IGetAppointmentFilter>({
            query: (params) => ({
                url: `api/adm/appointments`,
                method: 'GET',
                params:{...params}
            }),
            providesTags: ['appointment']

        }),

    })
})

export const {
    useLazyGetAppointmentsQuery
} = endpoints